import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
const getRefundRules = rule => typeof I18n.t(`pages.account.return_order.refund_rules.${rule}`) === 'string' ? I18n.t(`pages.account.return_order.refund_rules.${rule}`) : null;
export default class RefundRules extends PureComponent {
  render() {
    const {
      rules
    } = this.props;
    if (isEmpty(rules)) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "order-return__compliance-rules"
    }, /*#__PURE__*/React.createElement("p", {
      className: "order-return__compliance-rules-title"
    }, I18n.t('components.OrderReturn.compliance.rules.title')), /*#__PURE__*/React.createElement("ul", null, rules.map(rule => getRefundRules(rule) && /*#__PURE__*/React.createElement("li", {
      key: rule
    }, /*#__PURE__*/React.createElement("p", {
      className: "order-return__compliance-rules-rule"
    }, getRefundRules(rule))))));
  }
}
RefundRules.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.string)
};